import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, PlayCircle, TrendingUp, History, Activity, LogOut, Search, ShieldAlert } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { LogoLockup } from '@/components/Logo';

const items = [
  { to: '/dashboard', label: 'Briefing', icon: Home, testId: 'nav-briefing' },
  { to: '/ejecutar', label: 'Ejecutar pipeline', icon: PlayCircle, testId: 'nav-ejecutar' },
  { to: '/posiciones', label: 'Posiciones', icon: TrendingUp, testId: 'nav-posiciones' },
  { to: '/logs', label: 'Panel de logs', icon: Search, testId: 'nav-logs' },
  { to: '/historial', label: 'Historial', icon: History, testId: 'nav-historial' },
  { to: '/estado', label: 'Estado del sistema', icon: Activity, testId: 'nav-estado' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  return (
    <aside
      className="hidden md:flex flex-col border-r border-border"
      style={{ background: 'linear-gradient(180deg, hsl(var(--brand-deep) / 0.28), hsl(var(--card)) 45%, hsl(var(--card)))' }}
      data-testid="sidebar"
    >
      <div className="px-4 py-4 border-b border-border">
        <LogoLockup size={26} tagline="Firma virtual multi-agente" />
      </div>
      <nav className="flex-1 py-2" data-testid="sidebar-nav">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            data-testid={it.testId}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2 text-sm border-l-2 transition-colors duration-150 ${
                isActive
                  ? 'border-[hsl(var(--brand-accent))] bg-muted text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/60'
              }`
            }
          >
            <it.icon size={16} />
            <span>{it.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="px-4 py-3 text-[11px] text-muted-foreground border-t border-border flex items-center gap-2">
        <ShieldAlert size={13} className="text-[hsl(var(--warning))]" />
        <span>MVP · datos simulados</span>
      </div>
      <div className="p-3 border-t border-border">
        {user && (
          <div className="flex items-center gap-2 mb-3">
            {user.picture ? (
              <img src={user.picture} alt="" className="w-7 h-7 rounded-full border border-border" />
            ) : (
              <div className="w-7 h-7 rounded-full bg-muted" />
            )}
            <div className="min-w-0">
              <div className="text-xs truncate" data-testid="sidebar-user-name">{user.name || 'Jorge'}</div>
              <div className="text-[11px] text-muted-foreground truncate">{user.email}</div>
            </div>
          </div>
        )}
        <button
          data-testid="btn-logout"
          onClick={logout}
          className="w-full flex items-center justify-center gap-2 text-xs py-1.5 rounded-md border border-border hover:bg-muted transition-colors"
        >
          <LogOut size={14} /> Salir
        </button>
      </div>
    </aside>
  );
}
